import { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getSrc } from './video-utils';
import { videoPlugin } from './video';
import SingleInputWithOkAndCancel from '../../input-and-go/SingleInputWithOkAndCancel';
import styles from './video-menu-item.module.less';
import youtubeIcon from '@sb1/ffe-icons/icons/open/300/md/youtube_activity.svg';
import { Icon } from '@sb1/ffe-icons-react';
import { Tooltip } from '../tooltip/Tooltip';

const videoInputCreator = ({ setEditorState, getEditorState = () => {} }) => {
    return class VideoInput extends Component {
        static propTypes = {
            style: PropTypes.shape(),
            theme: PropTypes.shape(),
        };

        constructor(props) {
            super(props);
            this.state = {};
        }

        onInsertClick = () => {
            const editorState = getEditorState();

            const src = getSrc({ src: this.textInput.value });

            if (src) {
                const newEditorState = videoPlugin.addVideo(editorState, { src });
                setEditorState(newEditorState);
                this.props.onOverrideContent(undefined);
            } else {
                this.setState({
                    error: 'Lenken du forsøker å bruke er ikke en gyldig Youtube eller Vimeo-lenke',
                });
            }
        };

        render() {
            return (
                <div className={styles.inputAndGo}>
                    <SingleInputWithOkAndCancel
                        placeholder="YouTube- eller Vimeo-lenke"
                        innerRef={(input) => (this.textInput = input)}
                        onChange={() => this.setState({ error: '' })}
                        onGo={this.onInsertClick}
                        onCancel={() => this.props.onOverrideContent(undefined)}
                        error={this.state.error}
                    />
                </div>
            );
        }
    };
};

export default class VideoMenuItem extends Component {
    static propTypes = {
        getEditorState: PropTypes.func,
        setEditorState: PropTypes.func,
        style: PropTypes.shape(),
        theme: PropTypes.shape(),
    };

    toggleVideo = (event) => {
        event.preventDefault();
        const { setEditorState, getEditorState } = this.props;
        const editorState = getEditorState();
        const currentContent = editorState.getCurrentContent();
        const selectionState = editorState.getSelection();
        const anchorKey = selectionState.getAnchorKey();
        const currentContentBlock = currentContent.getBlockForKey(anchorKey);
        const start = selectionState.getStartOffset();
        const end = selectionState.getEndOffset();
        const src = (currentContentBlock.getText().slice(start, end) || '').trim();

        if (src.length === 0) {
            return this.props.onOverrideContent(videoInputCreator({ setEditorState, getEditorState }));
        }

        const isValidSource = getSrc({ src });
        if (isValidSource) {
            const newEditorState = videoPlugin.addVideo(editorState, { src });
            setEditorState(newEditorState);
        }
    };

    styleIsActive = () => {
        const { style, getEditorState } = this.props;

        if (getEditorState) {
            return getEditorState().getCurrentInlineStyle().has(style);
        }
    };

    render() {
        const { theme } = this.props;

        return (
            <Tooltip text="Youtube eller Vimeo">
                <button
                    className={classnames(
                        {
                            [theme.active]: this.styleIsActive(),
                            [theme.button]: true,
                        },
                        styles.videoMenuItem
                    )}
                    onClick={this.toggleVideo}
                >
                    <Icon fileUrl={youtubeIcon} />
                </button>
            </Tooltip>
        );
    }
}
